import { useState, useEffect } from 'react'
import useEdgeDataFetcher from './useEdgeDataFetcher'

export default (landingContext, updateGlobalState, globalState) => {
  const recaptchaDisabled = !!(globalState.environment && globalState.environment.recaptchaDisabled)
  const [response, verifyRecaptcha] = useState()
  const body = { ResponseToken: response }
  const [recaptchaData] = useEdgeDataFetcher(!recaptchaDisabled && response && `/recaptcha/verify?a=b`, JSON.stringify(body), 'POST')

  const recaptchaVerified = recaptchaDisabled || (!!recaptchaData && !!recaptchaData.success)
  const globalRecaptchaVerified = !!globalState.recaptchaVerified

  useEffect(() => {
    if (globalRecaptchaVerified !== recaptchaVerified) updateGlobalState({ recaptchaVerified })
  }, [updateGlobalState, recaptchaVerified, globalRecaptchaVerified])

  landingContext.verifyRecaptcha = verifyRecaptcha
}
